export const palette = {
  digitalRed: '#b53133',
  technicallyYellow: '#f3b600',
  coolantBlue: '#56b8b6',
  plasmaPurple: '#7000ff',
  practicallyPink: '#fa5700',
  rustRed: '#e87f62',
  socialBlue: '#1da1f1',
  midnightBlack: '#000000',
  charcoalGrey: '#414142',
  warmGrey: '#d7d7d8',
  white: '#fff'
};